import { render, staticRenderFns } from "./StudioApiDocs.vue?vue&type=template&id=5e8ae603&scoped=true"
import script from "./StudioApiDocs.vue?vue&type=script&lang=js"
export * from "./StudioApiDocs.vue?vue&type=script&lang=js"
import style0 from "./StudioApiDocs.vue?vue&type=style&index=0&id=5e8ae603&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8ae603",
  null
  
)

export default component.exports